import DataTable from "react-data-table-component-footer";
import { useContext, useEffect, useState } from "react";
import ErrorBoundaryWrapper from "@views/common/error-boundary-wrapper";
import { NoDataComponent } from "../no-data-component";
// ** Custom Components
import Paginate from "@components/ui-components/paginate";
// ** Constants
import { ROW_PER_PAGINATION_OPTIONS } from "@constants/index";
import { ThemeContext } from "@context/theme";
import classnames from "classnames";
import size from "lodash/size";
import { useLocation } from "react-router-dom";
import useSearchParams from "@hooks/use-search-params";

const PaginationDataTable = (props) => {
    const {
        columns = [],
        loading = false,
        defaultLimit = 10,
        pagination: { page, total, limit = defaultLimit, count } = {},
        handlePerRowsChange = () => {},
        handlePageChange = () => {},
        fixed = false,
        dense = false,
        conditionalRowStyles,
        getStartedComp = null,
        customNoData = null,
        className = "",
        expandableRows = false,
        expandableRowsComponent,
        paginationRowsPerPageOptions = ROW_PER_PAGINATION_OPTIONS,
        showPagination = true,
        pagination = {},
        footer = {},
        data = [],
        defaultSortFieldId = "",
        ...otherProps
    } = props;

    const ExpandableRowsComponent = () => { return expandableRowsComponent; };

    const CustomPagination = ({
        rowsPerPage,
        rowCount,
        onChangePage,
        onChangeRowsPerPage,
        currentPage
    }) => {
        const handlePageChange = (page) => {
            onChangePage(page);
        };
        return (
            <Paginate
                limit={rowsPerPage}
                paginationRowsPerPageOptions={paginationRowsPerPageOptions}
                handleLimit={onChangeRowsPerPage}
                handlePageChange={handlePageChange}
                currentPage={currentPage}
                count={rowCount}/>
        );
    };

    const { getSearchParams } = useSearchParams();

    const noRecordView = () => {
        if (getStartedComp && !total) {
            return getStartedComp;
        }
        if (customNoData) {
            return customNoData;
        }
        return <NoDataComponent />;
    };

    const [tempLimit, setTempLimit] = useState();

    useEffect(() => {
        setTempLimit(Number(getSearchParams("limit")) || limit);
    }, [getSearchParams("limit")]);

    const { filterOpen, handleFilterFocus } = useContext(ThemeContext);
    const { pathname } = useLocation();

    useEffect(() => {
        if (filterOpen) {
            handleFilterFocus();
        }
    }, [pathname]);

    return (
        <ErrorBoundaryWrapper name="tables"
            children={ 
                <div
                    className={classnames({
                        "pagination-dataTable": size(pagination),
                        [className]           : className,
                        "filter-open"         : filterOpen
                    })}>
                    {tempLimit ? (
                        <DataTable
                            noHeader
                            pagination={showPagination}
                            columns={columns.map((item) => ({
                                ...item,
                                name: item.name,
                                id  : item.id || item.name
                            }))}
                            paginationPerPage={tempLimit}
                            progressPending={loading}
                            footer={footer}
                            footerBold
                            defaultSortField={defaultSortFieldId}
                            paginationComponent={CustomPagination}
                            progressComponent={
                                <div style={{ width: "600px" }}></div>
                            }
                            fixedHeaderScrollHeight={"calc(100vh - 11.5rem)"}
                            className={classnames("react-dataTable", {
                                "fixed-column": fixed,
                                dense,
                                "no-data"     : !size(data),
                                loading 
                            })}
                            paginationServer={!!size(pagination)}
                            responsive
                            conditionalRowStyles={conditionalRowStyles}
                            striped
                            paginationTotalRows={count}
                            noDataComponent={noRecordView()}
                            onChangeRowsPerPage={handlePerRowsChange}
                            onChangePage={handlePageChange}
                            dense={dense}
                            defaultSortAsc={false}
                            paginationDefaultPage={page}
                            paginationRowsPerPageOptions={paginationRowsPerPageOptions}
                            fixedHeader
                            {...otherProps}
                            expandableRows={expandableRows}
                            expandableRowsComponent={
                                (expandableRowsComponent ? ExpandableRowsComponent() : <></>)
                            }
                            expandableRowExpanded={(row) => row.defaultExpanded}
                            data={data}/>
                    ) : null}
                </div>
            }/>
    );
};

export default PaginationDataTable;
